/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";

import defineConf from "../../config/defineConf";

function MomSysMstMaterialUpdateButton ( props ) {
    const {t} = useTranslation();
    const {id, schema, refresh, onSuccess, grid, ...others} = props;
    const [formData, setFormData] = useState();
    const [open, setOpen] = useState(false);
    
    const onOpen = () => {
        if (grid) {
            setFormData ({...(grid.selectedItems[0])});
        }
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess (msg);
        }
        refresh.refresh ();
    };

    const checkShowCallback = (formData, column) => {
        if (formData.opCode === defineConf.opCode.PUR2) {
            formData.cutCode1 = null;
            formData.cutCode2 = null;

            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return false;

                default :
                    return true;
            }
        } else {
            switch(column.name) {
                case "cutCode1" : 
                case "cutCode2" : 
                    return true;

                default :
                    return true;
            }
        }
    }

    return (
        <>
            <UpdateRecordButtonLayout id={id+"update-button"} onClick={onOpen} {...others} />
            <AutoFormDialog
                id={id+"update-dialog"}
                mode="edit"
                formId={id+"update-form"}
                title={t(`dialog.title.MomSysMstMaterial.update`)}
                schema={schema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                checkShowCallback = {checkShowCallback}
            />
        </>
    );
}

export default MomSysMstMaterialUpdateButton;

